import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class DeviceWideProfileAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'deviceWideProfile';

	getLastScanIpPort(scanId) {
		let request = {
			url: [this.getAPIUrl(), 'scan', scanId, 'ipport'].join('/'),
		};

		return httpClient.getAsync(request);
	}

	getLastResult(id) {
		let request = {
			url: [this.getAPIUrl(), id, 'last-result'].join('/'),
		};

		return httpClient.getAsync(request);
	}
	import(payload) {
		let request = {
			url: [this.getAPIUrl(), 'import'].join('/'),
			data: payload,
			headers: {
				"Content-Type": "multipart/form-data"
			}
		};

		return httpClient.postAsync(request);
	}

	getResult(id) {
		let request = {
			url: [this.getAPIUrl(), id, 'result'].join('/'),
		};

		return httpClient.getAsync(request);
	}
}

export default new DeviceWideProfileAPI();
